module.exports = __webpack_public_path__ + "img/08_animal.1af7a1b9.jpg";